import rollbar from '@/utils/rollbar';

export enum SpreadType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE',
}

export enum Currency {
  USDT = 'USDT',
  BRL = 'BRL',
}

export enum ExchangeService {
  Awesome = 'AWESOME',
  Bitso = 'BITSO',
  BlockRiver = 'BLOCK_RIVER',
  OperatorOne = 'TRADING_VIEW', // Kept for compatibility, but should be renamed to OPERATOR_1
  OperatorTwo = 'OPERATOR_2',
  ENor = 'ENOR',
  Greenlabs = 'GREENLABS',
}

export type ExchangeLimits = {
  minAmount?: number;
  maxAmount?: number;
};

export const EXCHANGE_LIMITS: Record<ExchangeService, ExchangeLimits> = {
  [ExchangeService.Awesome]: {},
  [ExchangeService.Bitso]: {},
  [ExchangeService.BlockRiver]: {},
  [ExchangeService.OperatorOne]: {},
  [ExchangeService.OperatorTwo]: {},
  [ExchangeService.ENor]: {},
  [ExchangeService.Greenlabs]: {
    minAmount: 10000,
    maxAmount: 500000,
  },
};

export function getExchangeLimits(service: ExchangeService): ExchangeLimits {
  return EXCHANGE_LIMITS[service] || {};
}

// Active exchanges sorted by priority
export const EXCHANGES: ExchangeService[] = [
  ExchangeService.Awesome,
  ExchangeService.OperatorOne,
  ExchangeService.Greenlabs,
  ExchangeService.BlockRiver,
  ExchangeService.OperatorTwo,
  ExchangeService.ENor,
];

const EXCHANGE_SERVICE_LABELS: Record<ExchangeService, string> = {
  [ExchangeService.Awesome]: 'Awesome',
  [ExchangeService.Bitso]: 'Bitso Exchange',
  [ExchangeService.BlockRiver]: 'Block River',
  [ExchangeService.OperatorOne]: 'Operadora 1',
  [ExchangeService.OperatorTwo]: 'Operadora 2',
  [ExchangeService.ENor]: 'eNor',
  [ExchangeService.Greenlabs]: 'Greenlabs',
};

export const EXCHANGE_SERVICE_OPTIONS = EXCHANGES.map((exchange) => ({
  value: exchange,
  label: EXCHANGE_SERVICE_LABELS[exchange],
}));

export function getExchangeServiceLabel(service: ExchangeService, strict = false): string {
  const label = EXCHANGE_SERVICE_LABELS[service];
  if (!label && strict) {
    rollbar.error('Exchange service label not found', { service });
  }
  return label || service;
}

const CURRENCY_LABELS: Record<Currency, string> = {
  [Currency.USDT]: 'Tether (USDT)',
  [Currency.BRL]: 'Real (BRL)',
};

const CURRENCY_LABELS_COMPACT: Record<Currency, string> = {
  [Currency.USDT]: 'USDT',
  [Currency.BRL]: 'BRL',
};

export function getCurrencyLabel(currency: Currency): string {
  return CURRENCY_LABELS[currency] || currency;
}

export function getCurrencyLabelCompact(currency: Currency): string {
  return CURRENCY_LABELS_COMPACT[currency] || currency;
}

const SPREAD_TYPE_LABELS: Record<SpreadType, string> = {
  [SpreadType.Fixed]: 'Fixo',
  [SpreadType.Percentage]: 'Percentual',
};

export const SPREAD_TYPE_OPTIONS = Object.entries(SPREAD_TYPE_LABELS).map(([key, value]) => ({
  value: key as SpreadType,
  label: value,
}));

export function getUserSpreadTypeLabel(type: SpreadType): string {
  return SPREAD_TYPE_LABELS[type] || type;
}
